import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"
import { withTranslation } from "react-i18next"

import ArrowDownIcon from "../../../images/icons/arrow_down.svg"
import "./career-faq.sass"

class CareerFaq extends React.Component {
  constructor(props) {
    super(props)

    let activeIndex = null

    this.state = {
      activeIndex: activeIndex,
    }
  }

  componentDidMount() {
    this.update()
  }

  update() {
    if (document) {
      const faqItems = document.querySelectorAll("._fp-faq-items__item")
      faqItems.forEach((faqItem) => {
        const faqAnswer = faqItem.querySelector("._fp-faq-items__item__answer")

        if (!faqAnswer) {
          return
        }
        faqItem.style.paddingBottom = faqAnswer.scrollHeight + "px"
        faqAnswer.style.height = faqAnswer.scrollHeight + "px"
      })
    }
  }

  toggleChildren(index) {
    const currIndex = this.state.activeIndex

    let newIndex = index
    if (currIndex === newIndex) {
      newIndex = null
    }
    this.setState({ activeIndex: newIndex })
  }

  render() {
    const { t } = this.props

    return (
      <div className={"_fp-faq-items"}>
        {this.props.faqItems.map((item, index) => {
          return (
            <div
              key={index}
              className={classNames("_fp-faq-items__item", {
                "_fp-faq-items__item--hide-answer":
                  this.state.activeIndex !== index,
              })}
            >
              <button
                onClick={() => {
                  this.toggleChildren(index)
                }}
                className="_fp-faq-items__item__question _fp-heading-4"
              >
                <div>{item.translatedQuestion}</div>
                <div
                  className={"_fp-faq-items__item__question__icon-container"}
                >
                  <div
                    className={
                      "_fp-faq-items__item__question__icon-container__icon"
                    }
                  >
                    <ArrowDownIcon />
                  </div>
                </div>
              </button>
              <div className="_fp-faq-items__item__answer">
                <div className="_fp-faq-items__item__answer__item _fp-text">
                  {item.translatedAnswer}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  }
}

CareerFaq.propTypes = {
  faqItems: PropTypes.arrayOf(
    PropTypes.shape({
      translatedAnswer: PropTypes.string.isRequired,
      translatedQuestion: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
}

export default withTranslation()(CareerFaq)
